import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { UploadIcon } from './UploadIcon';
import { ProgressIndicator } from './ProgressIndicator';
import { DragUi, DragUiContent } from './styles';

const DragAndDrop: React.FC<{
  isDragging: boolean;
  isUploading: boolean;
  uploadsProgress: number;
  uploadsCount: number;
}> = ({ isDragging, isUploading, uploadsProgress, uploadsCount }) => {
  const { t } = useTranslation();
  const dragUiActive = isDragging || isUploading ? 'active' : '';

  return (
    <DragUi className={dragUiActive}>
      <DragUiContent className={isDragging ? 'active' : ''}>
        <UploadIcon />
        <h4>{t('content.dragAndDrop.dropTitle')}</h4>
      </DragUiContent>
      <DragUiContent className={isUploading ? 'active' : ''}>
        <ProgressIndicator percentage={uploadsProgress} />
        <h4>{t('content.dragAndDrop.progress', { count: uploadsCount })}</h4>
      </DragUiContent>
    </DragUi>
  );
};

export default DragAndDrop;

DragAndDrop.propTypes = {
  isDragging: PropTypes.bool.isRequired,
  isUploading: PropTypes.bool.isRequired,
  uploadsProgress: PropTypes.number.isRequired,
  uploadsCount: PropTypes.number.isRequired,
};
